"use strict";
/**
 * @module events
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var navigation_1 = __importDefault(require("./navigation"));
var add_to_cart_1 = __importDefault(require("./add-to-cart"));
/**
 * This class is responsible for handling events.
 *
 * It is responsible for exposing the public methods for triggering each different type of event.
 */
var EventsApi = /** @class */ (function () {
    /** @internal */
    function EventsApi(logger, options) {
        this.logger = logger;
        this.options = options;
    }
    /**
     * Triggers the `navigation` event.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     const options = { hasEnhancedContent: true, productIdType, productId };
     salsify.events.navigation(options);
     ```
     * @param options the options to pass to the event handler
     */
    EventsApi.prototype.navigation = function (options) {
        var _a;
        new navigation_1.default(this.logger).handle(options);
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onNavigation) {
            this.options.onNavigation(options);
        }
    };
    /**
     * Triggers the `addToCart` event.
     *
     * **Usage**
     ```javascript
     const salsify = window.salsifyExperiencesSdk;
     const options = { hasEnhancedContent: true, quantity: 1, productIdType, productId };
     salsify.events.addToCart(options);
     ```
     * @param options the options to pass to the event handler
     */
    EventsApi.prototype.addToCart = function (options) {
        new add_to_cart_1.default(this.logger).handle(options);
    };
    return EventsApi;
}());
exports.default = EventsApi;
//# sourceMappingURL=index.js.map